import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';


import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

// URL to web api
const baseApiUrl = '';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

@Injectable({
  providedIn: 'root'
})
export class FuturePlansListService {
  constructor(private http: HttpClient) {}

  getFuturePlansList(custId : any): Observable<any> {
    const get_url = baseApiUrl + 'subscriber/getFuturePlanList/' + custId;
    return this.http.get<any>(get_url,
      { headers: httpOptions.headers }).pipe(
        map(res => res),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
  activatePlan(obj){
    const post_url = baseApiUrl + 'subscriber/activatePlan' ;
    return this.http.post<any>(post_url,obj,
      { headers: httpOptions.headers })
  }
  activatePlanFuture(custId,custPackId){
    const get_url = baseApiUrl + 'subscriber/getCustomerCancellablePlans/'+ custId +"/"+ custPackId ;
    return this.http.get<any>(get_url)
  }
}